import { IgTypography } from "@intelligems/ig-theme";
import { Box, keyframes, Stack } from "@mui/material";

import { RuleGraphView } from "./RuleGraphView";
import { RULE_GRAPH_SKELETON_PLACEHOLDER } from "./skeleton";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";

/**
 * A graph that does not exist yet, shown as the thing being built: the
 * placeholder graph in skeleton mode under a heading that says what is
 * happening. The placeholder's shape is generic scenery, not the rule's real
 * structure — the copy is what keeps that honest.
 *
 * Shared by the Selection logic tab's pending state and the create flow's
 * "Atlas is designing this rule" view, so the canvas the author watches is
 * the same one the finished graph lands on.
 */
export const GraphBuildingState = ({
  title,
  hint,
}: {
  title: string;
  hint: string;
}) => (
  <Stack sx={{ flex: 1, minHeight: 0, p: 2 }} spacing={1}>
    <Stack spacing={0.25}>
      <IgTypography variant="body1" fontWeight={600}>
        {title}
      </IgTypography>
      <IgTypography variant="body2" color="text.secondary">
        {hint}
      </IgTypography>
    </Stack>
    <Box
      sx={{
        animation: `${fadeIn} 240ms ease-out`,
        display: "flex",
        flex: 1,
        minHeight: 0,
        [REDUCED_MOTION]: { animation: "none" },
      }}
    >
      <RuleGraphView graph={RULE_GRAPH_SKELETON_PLACEHOLDER} skeleton />
    </Box>
  </Stack>
);
